/// <amd-module name="TFS/Admin/Views/AdminHub/HighRiskSettingsIcon" />
import React = require("react");

import { Components } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";

class HighRiskSettingsIcon extends React.Component {
    public render(): JSX.Element {
        return Icon({ className: "icon-margin high-risk-settings-icon", iconName: "ReportHacked" });
    }
}

Components.add("settings.highRiskSettingsIcon", HighRiskSettingsIcon);
